export default "__VITE_ASSET__D2Aqncl___"